import axios from 'axios'
import {ResponseObjectPaginated, ResponseObject, ResponseCRUD, ParamsModel} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL
export function getParams(dto: any, page: number, tablaName: string = '') {
  return axios.post<ResponseObjectPaginated<ParamsModel[]>>(
    `${BASEURL}/master/getAll?pageNumber=${page}&tableName=${tablaName}`,
    dto,
  )
}
export function getParamsTable(dto: any, page: number, tablaName: string = '') {
  return axios.post<ResponseObjectPaginated<ParamsModel[]>>(
    `${BASEURL}/master/getAllParameters/${page}?tableName=${tablaName}`,
    dto,
  )
}
export function getParamsById(dto: any | undefined) {
  return axios.get<ResponseObject<ParamsModel>>(
    `${BASEURL}/master/getInformationById?supplierId=${dto}`,
  )
}

export function createParams(dto: ParamsModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/Master`, dto)
}

export function updateParams(dto: ParamsModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/Master`, dto)
}

export function deleteParams(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/Master/DeleteMaster?id=${dto}`)
}

export function getDataType() {
  return axios.get<ResponseObjectPaginated<any[]>>(`${BASEURL}/master/getDataType`)
}
